import { Close } from "@mui/icons-material";
import {
  Box,
  Fade,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { TableRow } from "@aws-amplify/ui-react";
import { useSelector } from "react-redux";
import { API, graphqlOperation } from "aws-amplify";
import { getLinkedReceipts } from "../../../graphql";
import moment from "moment";
import { MoneyFormatv3 } from "../../../library/MoneyFormat";
import { useThemes } from "../../../components/Theme/theme";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  minWidth: "500px",
};
function ViewTransactionDetails({ open, setOpen, Type, accountID, data }) {
  const paymentHeader = [
    {
      id: "slno",
      label: "SL.No",
      align: "left",
      width: "100px",
    },
    {
      id: "date",
      label: Type === "Purchase" ? "Payment Date" : "Receipt Date",
      align: "left",
      width: "100px",
    },
    {
      id: "No",
      label: Type === "Purchase" ? "Payment No" : "Receipt No",
      align: "left",
      width: "100px",
    },
    {
      id: "amount",
      label:
        Type === "Purchase"
          ? `Payment Amount (${data.currency.sign})`
          : `Receipt Amount (${data.currency.sign})`,

      align: "right",
      width: "100px",
    },
    // {
    //   id: "balance",
    //   label:
    //     Type === "Purchase"
    //       ? `Balance In Payment (${data.currency.sign})`
    //       : `Balance In Receipt (${data.currency.sign})`,

    //   align: "right",
    //   width: "100px",
    // },
  ];
  const [backDropOpen, setBackdropOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalReceivedAmt, setTotalReceivedAmt] = useState(0);
  const { theme } = useThemes();
  const handleClose = () => {
    setOpen(false);
  };

  const userPrefrenceandFY = useSelector(
    (state) => state.userPrefrenceandReducer
  );

  async function getTransactionDetailsByAccID() {
    try {
      let arr = [];
      let obj = {
        date: "",
        vouchNo: "",
        linkedAmount: 0,
      };
      const vouchernumber =
  data?.voucherNumber?.trim() ? data.voucherNumber : data?.seriesVouchers?.label;
      const res = await API.graphql(
        graphqlOperation(getLinkedReceipts, {
          vouchernumber: vouchernumber,
        })
      );

      if (res?.data?.getLinkedReceipts?.length > 0) {
        let totReceivedAmt = 0;
        res?.data?.getLinkedReceipts?.map((ele) => {
          obj = {
            date: moment.unix(ele?.enteredtimestamp).format("DD-MM-YYYY"),
            vouchNo: ele?.receiptvouchernumber,
            linkedAmount: Number(ele.linkedamount),
            balanceAmt: Number(ele.balancedueamount),
          };
          arr.push(obj);
          totReceivedAmt += Number(ele.linkedamount);
        });
        setTotalReceivedAmt(totReceivedAmt);
      }

      setRows(arr);
    } catch (err) {
      console.log(err);
    }
  }
  useEffect(() => {
    getTransactionDetailsByAccID();
  }, [data?.voucherNumber,data?.seriesVouchers]);
  return (
    <Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {Type === "Purchase" ? "View Payments" : "View Receipts"}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <Close sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                backgroundColor: "white",
                padding: "15px",
                height: { xs: "400px", sm: "auto" },
                overflowY: { xs: "scroll", sm: "hidden" },
                ".MuiTableCell-root": {
                  padding: "10px 10px",
                  fontSize: "13px",
                },
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: "400px",
                }}
              >
                <Table sx={{}} aria-label="simple table">
                  <TableHead sx={{ color: theme.palette.secondary.main }}>
                    <TableRow>
                      {paymentHeader.map((column, ind) => {
                        return (
                          <TableCell
                            key={ind}
                            sx={{
                              backgroundColor: theme.palette.secondary.main,
                              color: "#FFF",
                              align: column?.align,
                            }}
                          >
                            {column.label}{" "}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.length > 0 ? (
                      rows.map((ele, ind) => {
                        return (
                          <>
                            <TableRow key={ind}>
                              <TableCell>{ind + 1}</TableCell>
                              <TableCell>{ele?.date}</TableCell>
                              <TableCell>{ele?.vouchNo}</TableCell>
                              <TableCell align="right">
                                {MoneyFormatv3(
                                  Number(ele?.linkedAmount).toFixed(2),
                                  "en-IN"
                                )}
                              </TableCell>
                              {/* <TableCell align="right">
                              {MoneyFormatv3(
                                Number(ele?.balanceAmt).toFixed(
                                  2
                                ),
                                "en-IN"
                              )}
                            </TableCell> */}
                            </TableRow>
                          </>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={5}
                          align="center"
                          sx={{ textAlign: "center", verticalAlign: "middle" }}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    )}
                    {rows.length > 0 && (
                      <>
                        <TableRow>
                          <TableCell
                            colSpan={3}
                            align="center"
                            sx={{
                              textAlign: "left",
                              fontWeight:"bold"
                            }}
                          >
                            Total Received Amount
                            
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: "right",
                              fontWeight:"bold"
                            }}
                          >
                            {MoneyFormatv3(
                              Number(totalReceivedAmt).toFixed(2),
                              "en-IN"
                            )}
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
}

export default ViewTransactionDetails;
